module.exports = __webpack_public_path__ + "static/media/video-camera.98456911.png";